import React from "react";

export default function CardTitle(props) {
    return (
        <>
            <h3 className="font-bold text-xl mb-2 text-gray-800">{props.children}</h3>
        </>
    );
}